import { useState } from 'react'
import Slider from 'react-slick'
import type { Settings } from 'react-slick'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { useNavigate } from '../../../hooks/useNavigate'

import { CenterItem, ColumnItem } from '../../../components/common'

import { Color } from '../../../theme/color'

import 'slick-carousel/slick/slick.css'

interface RollingBannerProps {
  banners: components['schemas']['BannerDto'][]
}

const SETTINGS: Settings = { arrows: false, infinite: true }

export function RollingBanner({ banners }: RollingBannerProps) {
  const [currentSlide, setCurrentSlide] = useState<number>(0)
  const [isDrag, setIsDrag] = useState<boolean>(false)

  const navigate = useNavigate()

  const handleCurrentSlide = (_: number, next: number) => {
    setIsDrag(true)
    setCurrentSlide(next)
  }

  return (
    <ColumnItem $gap={8}>
      <SlideWrap>
        <Slider {...SETTINGS} beforeChange={handleCurrentSlide} afterChange={() => setIsDrag(false)}>
          {banners.map(({ id, imageUri, title, targetUrl }) => {
            const navigateUrl = () => {
              if (isDrag) return
              navigate(targetUrl)
            }

            return (
              <BannerCard key={id} onClick={navigateUrl}>
                <img src={imageUri} alt={title} />
              </BannerCard>
            )
          })}
        </Slider>
      </SlideWrap>
      {banners.length > 1 && (
        <CenterItem>
          {banners.map(({ id }, index) => {
            const isActive = currentSlide === index
            return <Dot key={id} $isActive={isActive} />
          })}
        </CenterItem>
      )}
    </ColumnItem>
  )
}

const SlideWrap = styled.div`
  overflow: hidden;
  width: calc(100% - 16px * 2);
  margin: 0 auto;
  border-radius: 8px;
  .slick-slide {
    aspect-ratio: 1 / 0.22;
  }
`

const BannerCard = styled.div`
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1 / 0.22;
  cursor: pointer;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Dot = styled.div<{ $isActive: boolean }>`
  width: ${({ $isActive }) => ($isActive ? 8 : 6)}px;
  height: ${({ $isActive }) => ($isActive ? 8 : 6)}px;
  margin: 0 ${({ $isActive }) => ($isActive ? 1.5 : 2)}px;
  border-radius: 50%;
  background-color: ${({ $isActive }) => ($isActive ? Color.black : Color.gray_3)};
`
